module.exports = __webpack_public_path__ + "img/tw.051cd417.svg";